import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface QuiltPlannerHeaderProps {
  showClear: boolean;
  onClear: () => void;
  cameFromRecentPlans?: boolean;
}

export const QuiltPlannerHeader = ({ showClear, onClear, cameFromRecentPlans = false }: QuiltPlannerHeaderProps) => {
  const navigate = useNavigate();
  
  const handleLogoClick = () => {
    if (showClear && !cameFromRecentPlans) {
      onClear();
    } else {
      navigate('/');
    }
  };

  const handleStartOverClick = () => {
    onClear();
  };
  
  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: 'background.default',
        color: 'text.primary'
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 2, sm: 3 } }}>
        <Typography 
          variant="h5" 
          component="button"
          onClick={handleLogoClick}
          sx={{ 
            color: 'primary.main',
            fontWeight: 700,
            fontSize: '1.25rem',
            letterSpacing: '-0.01em',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8
            }
          }}
        >
          Plan a quilt
        </Typography>
        
        {showClear && (
          <Button
            variant="text"
            startIcon={<Plus size={20} aria-hidden="true" focusable="false" />}
            onClick={onClear}
            sx={{
              color: 'text.secondary',
              '&:hover': {
                color: 'primary.main',
              },
              fontWeight: 600,
            }}
          >
            {cameFromRecentPlans ? 'PLAN NEW QUILT' : 'START NEW PLAN'}
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};